import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/svg/logo2.svg';
import manWithPc from '../../../assets/img/manWithPc.png';
import GirlWithLaptop from '../../../assets/img/girl-with-laptop.svg';
import { clsfy } from '../../../helpers';

const LeftSide = ({ header, para, add, route }) => {
  return (
    <div className="lg:flex-grow lg:w-2/4 hidden lg:block">
      <Link to='/' className='block lg:w-44 2xl:w-52 desktop:w-auto lg:ml-8 2xl:ml-20 desktop:ml-32'>
        <img src={logo} alt="Manuscripts" />
      </Link>
      <div className="lg:w-100 xl:w-104 mx-auto lg:mt-16 2xl:mt-14 desktop:mt-20">
        <h1 className="w-9/12 font-bold lg:text-3xl 2xl:text-4xl mb-3">
          {header}
        </h1>
        <p className="w-8/12 text-headerPara lg:text-base 2xl:text-xl ">
          {para}
          <Link
            to='/signup'
            className="lg:text-lg 2xl:text-2xl text-buttonColor ml-3 cursor-pointer"
          >
            {add}
          </Link>
        </p>
      </div>
      <div className={clsfy('mb-16 desktop:mt-40 flex justify-center', [
        route === 'login' ? 'mt-16' : 'mt-32'
      ])}>
        <img src={route === 'login' ? GirlWithLaptop : manWithPc} alt="Man with a Laptop." />
      </div>
    </div>
  );
};

export default LeftSide;
